import React, { Component, useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import cookie from 'react-cookies';
import { getGoals, getGoalQuestions, verifyPAN, cleanGoalsContent, getGoalSuggestions, encryptRSA, decryptAES, decrypttRSA, verifyOTP, encryptAES, encryptAESforKYC, resendOTP, savePreLoginData, cleanGoalsQuestion, cleanAuthContent, validateBasketSchemes } from '../../action';
import Slider from "../../../../general/Slider";
import Input from "../../../../general/Input/index";
import Authentication from "../Common/Authentication";
import { closePopup, openPopup } from "../../../../general/Modal/action";
import NoContent from "../../../../general/NoContent";
import { MODALS } from "../../../../general/Modal/constants";
import { ACTION } from "../../constants";
import './style.scss';
import '../style.scss';
import moment from "moment";
import ENV_CONFIG from '../../../../../../config/environment'
import { digitToRupeeNotation, convertAmountToWords } from '../../../../../../utils/common';

const Goals = (props) => {
    const { getGoals, getGoalQuestions, getGoalSuggestions, verifyPAN, cleanGoalsContent, closePopup, openPopup, verifyOTP, resendOTP, homePage, savePreLoginData, location, history, cleanGoalsQuestion, switchToRisk, cleanAuthContent, scrollHeight, validateBasketSchemes } = props;
    const ref = useRef('');
    const [journeyPage, setJourneyPage] = useState(0);
    const [kycData, setKycData] = useState(null);
    const [nextDisabled, setNextDisabled] = useState(true);
    const [OTP, setOtp] = useState(null);
    const [goalDescription, setGoalDescription] = useState(null);
    const [uuid, setUuid] = useState(null);
    const [values, setValues] = useState({});
    const [numberOfQuestions, setNumberOfQuestions] = useState(0);
    const [goalPlanningName, setgoalPlanningName] = useState('');
    const [riskAppetite, setRiskAppetite] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [selectedGoal, setSelectedGoal] = useState(null);
    const [showRiskAppetiteAnyway, setShowRiskAppetiteAnyway] = useState(false);
    const [basketDeatilsData, setbasketDeatilsData] = useState(null);
    const [editBasketValue, seteditBasketValue] = useState(true);
    const [editBasketTitle, seteditBasketTitle] = useState(true);
    const [goalAmount, setgoalAmount] = useState('');
    const [basketValidation, setbasketValidation] = useState('');
    const [goalAllQuestionData, setgoalAllQuestionData] = useState('');
    const [basketValidationError, setBasketValidationError] = useState({
        sipError: {},
        purchaseError: {},
    });
    const [authvalues, setAuthvalues] = useState({
        pan: '',
        dob: '',
        mobile: '',
        email: '',
    });
    const [redirectionLink, setRedirectionLink] = useState(null);
    const [error, setError] = useState({});
    // const [readMore, setReadMore] = useState(false);
    const inputValues = new Map([
        ["TIME", "years"],
        ["AGE", "years"],
        ["RETIREMENT_AGE", "years"],
        ["LIFE_EXPECTANCY", "years"],
        ["INFLATION", "%"],
        ["WITHDRAWAL_RATE", "%"],
        ["EXPENSE_MONTHS", "months"],
    ]);
    const singularInputValues = new Map([
        ["TIME", "year"],
        ["AGE", "year"],
        ["RETIREMENT_AGE", "year"],
        ["LIFE_EXPECTANCY", "year"],
        ["INFLATION", "%"],
        ["WITHDRAWAL_RATE", "%"],
        ["EXPENSE_MONTHS", "month"],
    ]);
    const values1 = {
        min: 2,
        max: 20,
        value: values.year,
        step: 1,
        unit: 'years',
    }
    const values2 = {
        min: 2000,
        max: 200000,
        value: values.amount,
        step: 1000,
    }
    useEffect(() => {
        if (authvalues.pan && authvalues.dob) {
            let object = {
                pan: authvalues.pan,
                dob: moment(authvalues.dob).format("DD-MMM-YYYY"),
                email: authvalues.email,
                mobile: authvalues.mobile,
            }
            setRedirectionLink(encryptAESforKYC(object));
        }
    }, [authvalues]);
    useEffect(() => {
        if (location && location.search === "") {
            setJourneyPage(0);
        }
    }, [location && location.search]);
    useEffect(() => {
        onLoad();
        return () => {
            onUnload();
        }
    }, []);

    useEffect(() => {
        let age = document.querySelectorAll('input[name$="AGE"]')[0];
        let retirementAge = document.querySelectorAll('input[name$="RETIREMENT_AGE"]')[0];
        let time = document.querySelectorAll('input[name$="TIME"]')[0];
        if (selectedGoal && selectedGoal.goalCategory === 'MY_NEST') {
            if (time && time.value && (parseInt(time.value) > 3)) {
                setShowRiskAppetiteAnyway(true);
            }
            else setShowRiskAppetiteAnyway(false);
        }
        else if (age && age.value && retirementAge && retirementAge.value && ((parseInt(retirementAge.value) - parseInt(age.value)) > 3)) {
            setShowRiskAppetiteAnyway(true);
        }
        else setShowRiskAppetiteAnyway(false);
    }, [values]);

    useEffect(() => {
        if ((Object.values(error).length === 0) && (Object.keys(values).length > 0) && (numberOfQuestions === (Object.keys(values).length))) {
            setNextDisabled(false);
        }
        else setNextDisabled(true);
    }, [error, values]);

    useEffect(() => {
        if (homePage.otpVerificationData.apiLoaded && homePage.otpVerificationData.data && homePage.otpVerificationData.data.uuid) {
            setUuid(homePage.otpVerificationData.data.uuid);
            const testt = async () => {
                let questionArray = [];
                if (homePage.goalsQuestion && homePage.goalsQuestion.data) {
                    Object.keys(values).map((item, index) => {
                        let object = {};
                        object.questionId = item.split("_")[0];
                        object.questionType = item.split(/_(.*)/s)[1];
                        object.answer = parseInt(Object.values(values)[index]);
                        questionArray.push(object);
                    })
                    let goalsSuggestionData = homePage.goalSuggestion.data;
                    setbasketDeatilsData(goalsSuggestionData && goalsSuggestionData.basketDetails);
                    setgoalAmount(goalsSuggestionData && goalsSuggestionData.amount ? goalsSuggestionData.amount : goalsSuggestionData && goalsSuggestionData.schemes && goalsSuggestionData.schemes[0].amount);
                    let params = {
                        goalId: homePage.goalsQuestion.data.goalId,
                        goalQuesAndAnsSet: questionArray,
                        journey: ACTION.JOURNEY.GOAL_JOURNEY,
                        step: 'FIRST',
                        panNumber: authvalues.pan,
                        timeInMonths: goalsSuggestionData && goalsSuggestionData.timeInMonths ? goalsSuggestionData.timeInMonths : '',
                        returnRate: goalsSuggestionData && goalsSuggestionData.returnRate ? goalsSuggestionData.returnRate : '',
                        amount: goalsSuggestionData && goalsSuggestionData.amount ? goalsSuggestionData.amount : goalsSuggestionData && goalsSuggestionData.schemes && goalsSuggestionData.schemes[0].amount,
                        transactionType: goalsSuggestionData && goalsSuggestionData.transactionType ? goalsSuggestionData.transactionType : '',
                        basket: goalsSuggestionData && goalsSuggestionData.basket,
                        schemes: goalsSuggestionData && goalsSuggestionData.schemes ? goalsSuggestionData.schemes : null,
                        basketDetails: goalsSuggestionData && goalsSuggestionData.basketDetails ? goalsSuggestionData.basketDetails : null,
                        nriFlag: cookie.load("taxData"),
                    }
                    if (riskAppetite) {
                        params.riskAppetite = riskAppetite && riskAppetite.toUpperCase().replace(/ /g, "_");
                    }
                    let schemeCodesInBasketArr = [];
                    if (goalsSuggestionData && goalsSuggestionData.basketDetails && goalsSuggestionData.basketDetails.schemesInBasket) {

                        goalsSuggestionData.basketDetails.schemesInBasket && goalsSuggestionData.basketDetails.schemesInBasket.length > 0 && goalsSuggestionData.basketDetails.schemesInBasket.map((item, index) => {

                            item.schemeCode && schemeCodesInBasketArr.push(item.schemeCode);
                        })
                    }
                    let validateParam = {
                        schemeCodes: schemeCodesInBasketArr,
                        transactionType: goalsSuggestionData && goalsSuggestionData.transactionType ? goalsSuggestionData.transactionType : '',
                    }
                    schemeCodesInBasketArr.length > 0 && await validateBasketSchemes(encryptAES(JSON.stringify(validateParam)));

                    let response = await savePreLoginData(encryptAES(JSON.stringify(params)), homePage.otpVerificationData.data.uuid);
                }
            }
            testt();
        }
    }, [homePage.otpVerificationData]);

    useEffect(() => {
        if (homePage && homePage.getBasketSchemes && homePage.getBasketSchemes.data && homePage.getBasketSchemes.data.validationDTOMap) {
            setbasketValidation(homePage.getBasketSchemes.data.validationDTOMap);
        }
    }, [homePage.getBasketSchemes]);

    const onLoad = async () => {
        let response1 = await getGoals();
        var queryParam = getQueryParams();
        if (queryParam && queryParam.journey && queryParam.journey === 'GOAL_PLANNING') {
            let response = await getGoalQuestions(queryParam.goalId);
            if (response && response.data && response.data.goalQuestions) {
                setNumberOfQuestions(response.data.goalQuestions.length);
            }
            setJourneyPage(1);
            setValues(cookie.load("GoalData"));
            setError(cookie.load("GoalErrors"));
            if (queryParam.riskAppetite) {
                setRiskAppetite(queryParam.riskAppetite.replace("_", " "));
            }
            setSelectedGoal((response1.data.goalDetailDTOList.filter(item => item.goalName === response.data.goalName))[0]);
            setShowRiskAppetiteAnyway(true);
        }
        // let test = encryptRSA("testing");
        // let test1 = decryptAES("j+EIANcvIJXHxVwpnuV8j6MOKdJjaTaX52Sk32sSlpqm7FTz+fU6FlJ9NVF9458uiNtLpD05sLanGd7ynYcPdg07GpRSN4NFtksebIgEHIeFwXnAuMnEo3MkHjE7C5NJ5te78hcXoc2AYSPLUJFlN+9DNvyAuuvk8zLu80OBZC0=|D8uVE3CssQG1zo0JPl/S4Evo41bMc0oQpiBhM29Msw0BGcjMT+HocPQ+C5/Wu2kngW0HH2PoOXlAqCCKCtCjCn5dPoQPtvWPDQIQms4t04kTlJC1CxTaVq7Gnsb9JLmddvQFFztX50P1GJuQfjnGC4E7tLJjd6gxayPL9qEmznWGQk8/o2fjmCCL46wPioJ5");
        // let test2 = decryptAES("jAmFscf+K5Xa5YLWfwzWLgXEFHF/LDmFPay8KIASL2iswFPml2lKpCuIAcvAnZPbQZLXf6gbFW3U6HIJvlqojmrNNBdwEU5QQI9RtJLwQBOc6BWCor5b5TER6dAywTVnTBQMK/UpsfYQSRO0ibfEcBGm8Xtgq6K5/rrS0gHcaoo=|tI35H/GHqFd21/Ai2gdjIYo/O/UTFOjicEZTbB9nSv9M51XnLQ2gfeIehL0khGTJODWrLen4vJIM1I8HGfD80EOWh+NGQLohHQy1td6cw3V1tQOdhoBpRdD1e9KymF0+atE47wZVp163mmkAxU2r0ldqA/pzXpHjr9/odJf1D8WJUKEp87OTh81NOmOx/RofmboNy2PatFFzwUVPqzyU7wN+erk//NoKA1QcoIbNcEfaQoIwyjIpDWIk0YVH75b9b58G3mi+R7mv6uh36cMhB+zaajwxnvVBngTrAx5Gx5gmhJ38BCyR6EGGSvIyU3ZE4Bbi5EfiYJ9IiLU+LK7XlQ0oKFRE6iV87oWdKuWratkEmh+nTFEwHUb5J4bIgbktrOyXKM6KFv1LNdRLIGT2021p9irJT6g031l+wvM1LvNjZPGkLrgQ0+yKOxz4x/fs0H04cRbyDKPJ6F2ngjRRDla0gcU0b4xB6s8by6hlRw9vOdQlme2GzD29F6b9c1imVRsUip4OQdN2qigJu6iIV6teQ/0vgC0nDZWTndLNcqR6Mm610ShWlLjbPO1qyhL1k7isWU3FMHMAGfKY9W5cHOF67AQ6NuGHbwQPJqkV/GBv7E/fDF4sqBXCkEGoei5U3U0hT7ai8wBrB47lkbR+l7/V2iV0snSvUQg1axNnHS4QUGvIJ0kbbIuXVFhwOFxDVCXfHwhVWP41K2r8xW7bfTHEcNDDg3mCUkGkHA0lxlYhMjxNELPMHcDPCxFgaZEr17mz+wwUleZNk3Gs/ovA9HjR6bfvKE1B9ECfqSuQq4BIPFoDqhIxTw1XJ3ZY/0car3ypxUmhvDn0XVcJbonG/KYv4N3UbIDCrgiQsm87o9+bKMWJ+LdgKpMPGRpQ02Nc6B+lff3FU1OMq+pDSNs9JslI2tA7ochfl/e33wl7xcvgLn209zUeOCA8EuY27fZmAMJ3um1sYhhAJgs2DhTsYwWDiCET/ShtSVuxMk6oX1BV2v/0Sn2OLQF6Eh6As+PIiLgqPPbdrFjy+oi9Ik/moHy514EoDHaa6ZLoUhGiXgprHHtDxlr112CpOL42kFPTSwuQVrADx+wleOW3hl1hBuGSHeeioQHyK5cZtG2ellj6VsgYl9USBQUq8hZ9soyT28eQ2STtvILbTE7BVGLe7RfY6H8Xx3OvovE1mrVzGynClCUmmBiONLNQGPxOG5K2cnn8+JdCX20CAHoNB3tyth9FyW0sgXrXzIBqY0GVt4KCR4WX7R5wsA/fyASkr6Q+JaCGkZ/wuR6S0jlW/bD/hj/Q14wjKrveMR4BPcLF8ebo/fENpTER8uV3pvMe8XKZM1yo5AFAVtP/4BEYqP2Knn1hod9sXve5KeKoRCicAN3a9NT8bb1O6wFYF5fw/yLr0ewKYmM5LdOyOvwkzWM53qgKZEwm1nb8SeP7tzorSiPSwilXTqinfVtoGFh27dHEnh+pGM4fsUutEodq1U+dhYOTsXbdrE0fniBLGJesGAi9tgQm2UXyUzTnE7hoqwZoEqbCFRHf1JtaWwq1ta7VtjQGq7JRT29Jd+X19LNc5++FzKGnK62vO0Hs3kHkn0mBgxmItBGdw7JNQtGI9tmBT+p+RJTlHg1RvnoChCjQDFwo6L3gRNFkRhy/IpRrCfSYJy6LTWCkB8u6dZYtSGf/gooFrIuV5TAnPtk5X2aWhQq1v5tahzrwlCQtEfcT2ajr1LQrsS06BjDaljf2kL0Ul1LfRi8gWvPoBPgjifPnyGQBNuLJ3FyFSxDwdl7riT00p2Z6yXfeTEgKHEE8wQMCLKRWGVhqH1sPyGpclLFjuZudYt+mxI6qwCXwuf+iQypFJKMiQSAgE/hpbBPnuiMKjA==");
        // let test3 = decrypttRSA("XCDMKRu6OvLZVfh0AWQwAU8RkaVN89aQcA5LVoFje9ZWDmjCRs+FTlSWWZrwWFXv/jPc2uWjyD6R7M6hOU+vd/kqdcBgKmWuNjmEVIIm1eEom68YFyVJAwGpW3/fcxPo1cwetRArcXQ67WOqkVXsHzcyQkuFN7fU1cYT/9KMRNw=");
        // // console.log("encrypted data", test);
        // console.log("payload", test2);
        // console.log("api response", test1);
        // console.log("resend otp", test3);
        // console.log(decryptAES("xF04U8FsYibToW4gFdnsZQ==|8CHZ+yIR43jEWCFnabSG30Uck0+h6lL9khVYVqg3w2E="));
    }

    const onUnload = () => {
        cleanGoalsContent();
    }
    const onAmountChange = (e) => {
        if (basketValidation && basketValidation[e.schemeCode] && basketValidation[e.schemeCode].validationType === "PURCHASE") {
            if (
                basketValidation && basketValidation[e.schemeCode] && e.value < (basketValidation[e.schemeCode].minAddlPurchaseAmt || basketValidation[e.schemeCode].minFirstPurchaseAmt)
            ) {
                setBasketValidationError(prevState => (
                    {
                        ...prevState,
                        purchaseError: {
                            ...prevState.purchaseError,
                            [e.schemeCode]: `Minimum amount should be ₹ ${basketValidation[e.schemeCode].minAddlPurchaseAmt ? basketValidation[e.schemeCode].minAddlPurchaseAmt : basketValidation[e.schemeCode].minFirstPurchaseAmt}`
                        }
                    }))
            }
            else if (
                basketValidation && basketValidation[e.schemeCode] && basketValidation[e.schemeCode].purchaseMultiple &&
                e.value % basketValidation[e.schemeCode].purchaseMultiple !== 0
            ) {
                setBasketValidationError(prevState => (
                    {
                        ...prevState,
                        purchaseError: {
                            ...prevState.purchaseError,
                            [e.schemeCode]: `Please Provide In multiples of ₹ ${basketValidation[e.schemeCode].purchaseMultiple}`
                        }
                    }))
            }
            else {
                setBasketValidationError(prevState => {
                    const updatedPurchaseError = { ...prevState.purchaseError };
                    delete updatedPurchaseError[e.schemeCode];
                    return {
                        ...prevState,
                        purchaseError: updatedPurchaseError,
                    };
                });
            }
        }
        else if (basketValidation && basketValidation[e.schemeCode] && basketValidation[e.schemeCode].validationType === "SIP") {
            if (
                basketValidation &&
                basketValidation[e.schemeCode] &&
                basketValidation[e.schemeCode].additionalValidation &&
                basketValidation[e.schemeCode].additionalValidation.OM &&
                basketValidation[e.schemeCode].additionalValidation.OM[0] &&
                basketValidation[e.schemeCode].additionalValidation.OM[0].min_amount_lower && e.value <
                basketValidation[e.schemeCode].additionalValidation.OM[0].min_amount_lower
            ) {
                setBasketValidationError(prevState => ({
                    ...prevState,
                    sipError: {
                        ...prevState.sipError,
                        [e.schemeCode]: `Minimum amount should be ₹ ${basketValidation[e.schemeCode].additionalValidation.OM[0].min_amount_lower}`
                    }
                }));
            }
            else if (
                basketValidation &&
                basketValidation[e.schemeCode] &&
                basketValidation[e.schemeCode].additionalValidation &&
                basketValidation[e.schemeCode].additionalValidation.OM &&
                basketValidation[e.schemeCode].additionalValidation.OM[0] &&
                basketValidation[e.schemeCode].additionalValidation.OM[0].amt_multiples &&
                e.value %
                basketValidation[e.schemeCode].additionalValidation.OM[0].amt_multiples !== 0
            ) {
                setBasketValidationError(prevState => ({
                    ...prevState,
                    sipError: {
                        ...prevState.sipError,
                        [e.schemeCode]: `Please Provide In multiples of ₹ ${basketValidation[e.schemeCode].additionalValidation.OM[0].amt_multiples}`
                    }
                }));
            }
            else if (
                basketValidation &&
                basketValidation[e.schemeCode] &&
                basketValidation[e.schemeCode].monMaxAmt &&
                basketValidation[e.schemeCode].monMaxAmt <= e.value
            ) {
                setBasketValidationError(prevState => ({
                    ...prevState,
                    sipError: {
                        ...prevState.sipError,
                        [e.schemeCode]: `This is a high value registration, we request you to contact (hello@hdfcfund.com) for assistance to complete your registration`
                    }
                }));
            }
            else {
                setBasketValidationError(prevState => {
                    const updatedPurchaseError = { ...prevState.sipError };
                    delete updatedPurchaseError[e.schemeCode];

                    return {
                        ...prevState,
                        sipError: updatedPurchaseError,
                    };
                });
            }
        }
        const newBasketDetailsData = {
            ...basketDeatilsData,
            schemesInBasket: basketDeatilsData.schemesInBasket.map((item) => {
                if (item.schemeName === e.name) {
                    return {
                        ...item,
                        amount: e.value == '' ? parseInt(0) : parseInt(e.value),
                    };
                }
                return item;
            }),
        };
        setbasketDeatilsData(newBasketDetailsData);

        let totalAmt = 0;
        newBasketDetailsData && newBasketDetailsData.schemesInBasket && newBasketDetailsData.schemesInBasket.length > 0 && newBasketDetailsData.schemesInBasket.map((item) => {
            totalAmt += item.amount;
        })
        setgoalAmount(totalAmt);
    }

    const handleSaveBasketData = () => {
        seteditBasketValue(true);
        seteditBasketTitle(false);
    }

    const handleResetBasketData = () => {
        seteditBasketValue(true);
        seteditBasketTitle(true);
        setBasketValidationError(prevState => ({
            ...prevState,
            sipError: {},
            purchaseError: {}
        }));
        if (homePage.goalSuggestion && homePage.goalSuggestion.data) {
            if (homePage.goalSuggestion.data.basketDetails) {
                setbasketDeatilsData(homePage.goalSuggestion.data.basketDetails);
            }
            if (homePage.goalSuggestion.data.amount) {
                setgoalAmount(homePage.goalSuggestion.data.amount);
            }
        }
    }

    const onStartInvestingNew = async () => {
        let questionArray = [];
        if (homePage.goalsQuestion && homePage.goalsQuestion.data) {
            Object.keys(values).map((item, index) => {
                let object = {};
                object.questionId = item.split("_")[0];
                object.questionType = item.split(/_(.*)/s)[1];
                object.answer = parseInt(Object.values(values)[index]);
                questionArray.push(object);
            })
            let goalsSuggestionData = homePage.goalSuggestion.data;
            let params = {
                goalId: homePage.goalsQuestion.data.goalId,
                goalQuesAndAnsSet: questionArray,
                journey: ACTION.JOURNEY.GOAL_JOURNEY,
                step: 'FIRST',
                panNumber: authvalues.pan,
                timeInMonths: goalsSuggestionData && goalsSuggestionData.timeInMonths ? goalsSuggestionData.timeInMonths : '',
                returnRate: goalsSuggestionData && goalsSuggestionData.returnRate ? goalsSuggestionData.returnRate : '',
                amount: goalsSuggestionData && goalsSuggestionData.amount ? goalsSuggestionData.amount : goalsSuggestionData && goalsSuggestionData.schemes && goalsSuggestionData.schemes[0].amount,
                transactionType: goalsSuggestionData && goalsSuggestionData.transactionType ? goalsSuggestionData.transactionType : '',
                basket: goalsSuggestionData && goalsSuggestionData.basket,
                schemes: goalsSuggestionData && goalsSuggestionData.schemes ? goalsSuggestionData.schemes.filter(item => item.schemeName === schemeName) : null,
                basketDetails: goalsSuggestionData && goalsSuggestionData.basketDetails ? goalsSuggestionData.basketDetails : null,
                nriFlag: cookie.load("taxData"),
                frequency: goalsSuggestionData && goalsSuggestionData.transactionType ? goalsSuggestionData.transactionType : '',
                isBasketCustomized: editBasketTitle ? false : true,
                customizedBasketDetails: {
                    totalAmount: goalAmount,
                    basketName: editBasketTitle ? goalsSuggestionData && goalsSuggestionData.basketDetails && goalsSuggestionData.basketDetails.basketName : goalsSuggestionData.suggestedBasketName,
                    schemesInBasket: basketDeatilsData && basketDeatilsData.schemesInBasket ? basketDeatilsData.schemesInBasket : null,
                }
            }
            if (riskAppetite) {
                params.riskAppetite = riskAppetite && riskAppetite.toUpperCase();
            }
            let response = await savePreLoginData(encryptAES(JSON.stringify(params)), homePage.otpVerificationData.data.uuid);
        }

        const url = homePage.otpVerificationData && homePage.otpVerificationData.data && homePage.otpVerificationData.data.uuid ? `${ENV_CONFIG.INVESTOR_BASE_URL}/invest-now?id=${homePage.otpVerificationData.data.uuid}` : '';
        cookie.load('GoalData') && cookie.remove('GoalData');
        cookie.load('GoalErrors') && cookie.remove('GoalErrors');
        setDisabled(true);
        setJourneyPage(0);
        setValues({});
        setError({});
        setAuthvalues(currentValue => ({
            ...currentValue,
            pan: '',
            dob: '',
            mobile: '',
            email: '',
        }));
        cleanAuthContent();
        window.open(url, '_blank');
    };
    const onBlur = (name, value) => {
        let element = document.getElementsByName(name)[0];
        let elementt = document.querySelectorAll('input[name$="COST_HOME"]')[0];
        let unit = element.nextSibling && element.nextSibling.innerHTML;
        if (name.includes("LIFE_EXPECTANCY")) {
            let elementt = document.querySelectorAll('input[name$="RETIREMENT_AGE"]')[0];
            if ((element.max && value > parseInt(element.max))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Life expectancy should be less or equal to ${(element.max)} years.`,
                }));
            }
            else if ((element.min && value < parseInt(element.min))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Life expectancy should be greater or equal to ${(element.min)} years.`,
                }));
            } else if ((value && elementt && elementt.value && ((value < parseInt(elementt.value)) || (value == parseInt(elementt.value))))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: 'Life expectancy needs to be greater than planning to retire age.',
                }));
            }
            else {
                setError(current => {
                    const copy = { ...current };
                    delete copy[elementt.name];
                    delete copy[name];
                    return copy;
                });
            }
        }
        else if (name.includes("RETIREMENT_AGE")) {
            let elementt = document.querySelectorAll('input[name$="AGE"]')[0];
            let elementtt = document.querySelectorAll('input[name$="LIFE_EXPECTANCY"]')[0];
            if (value && (value < parseInt(element.min))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Retirement Age should be greater or equal to ${element.min} years`,
                }));
            }

            else if (value && (value > parseInt(element.max))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Retirement Age should be less or equal to ${element.max} years`,
                }));
            }

            else if (value && ((value < elementt.value) || (value == elementt.value))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: 'Planning to retire age needs to be greater than your current age',
                }));
            }
            else {
                setError(current => {
                    const copy = { ...current };
                    delete copy[elementt.name];
                    delete copy[name];
                    return copy;
                });
            }
            if (value && ((value > parseInt(elementtt.value) || value == parseInt(elementtt.value)))) {
                setError(currentValue => ({
                    ...currentValue,
                    [elementtt.name]: 'Life expectancy needs to be greater than planning to retire age.',
                }));
            } else if (value && (value < parseInt(elementtt.value))) {
                setError(current => {
                    const copy = { ...current };
                    delete copy[elementtt.name];
                    return copy;
                });
            }
        }
        else if (name.includes("AGE") || name.includes("LIFE_EXPECTANCY")) {
            let elementt = document.querySelectorAll('input[name$="RETIREMENT_AGE"]')[0];
            if (value && (value < parseInt(element.min))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Age should be greater or equal to ${element.min} years`,
                }));
            }

            else if (value && (value > parseInt(element.max))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Age should be less or equal to ${element.max} years`,
                }));
            }

            else if ((!name.includes("LIFE_EXPECTANCY") && value && elementt && elementt.value && ((value > parseInt(elementt.value)) || (value == parseInt(elementt.value))))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: 'Current Age should be lesser than your Retirement age',
                }));
            }
            else {
                setError(current => {
                    const copy = { ...current };
                    delete copy[name];
                    delete copy[elementt.name];
                    return copy;
                });
            }
        }
        else if (name.includes("COST_HOME")) {
            let elementt = document.querySelectorAll('input[name$="PV"]')[0];
            if ((element.max && value > parseInt(element.max))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Maximum amount should be <span class="">${convertAmountToWords(element.max)}`,
                }));
            }
            else if ((element.min && value < parseInt(element.min))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Minimum amount should be <span class="">${convertAmountToWords(element.min)}`,
                }));
            }

            else {
                setError(current => {
                    const copy = { ...current };
                    delete copy[name];
                    return copy;
                });
            }
            if ((parseInt(value / 5) > parseInt(elementt.max))) {
                setError(currentValue => ({
                    ...currentValue,
                    [elementt.name]: `Maximum amount should be <span class="">${convertAmountToWords(elementt.max)}</span>`,
                }));
            }
            else if ((parseInt(value / 5) < parseInt(elementt.min))) {
                setError(currentValue => ({
                    ...currentValue,
                    [elementt.name]: `Minimum amount should be <span class="">${convertAmountToWords(elementt.min)}</span>`,
                }));
            }
            else if (parseInt(value / 5) === 0) {
                setError(currentValue => ({
                    ...currentValue,
                    [elementt.name]: `Amount cannot be zero`,
                }));
            }
            else {
                setError(current => {
                    const copy = { ...current };
                    delete copy[elementt.name];
                    return copy;
                });
            }
        }
        else if (elementt && name.includes("PV")) {
            if ((elementt.value && value > parseInt(elementt.value.replace(/,/g, ''))) || (elementt.value.toString().length === 0 && value > 0)) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Down payment cannot be more than current cost of home`,
                }));
            } else if ((element.max && value > parseInt(element.max))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Maximum amount should be <span class="">${convertAmountToWords(element.max)}`,
                }));
            } else if ((element.min && value < parseInt(element.min))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Minimum amount should be <span class="">${convertAmountToWords(element.min)}`,
                }));
            } else {
                setError(current => {
                    const copy = { ...current };
                    delete copy[name];
                    return copy;
                });
            }
        }
        else if ((!element.max) && (element.min && value < parseInt(element.min))) {
            setError(currentValue => ({
                ...currentValue,
                [name]: `Minimum amount should be <span class="">${convertAmountToWords(element.min)}</span>`,
            }));
        }
        else if ((element.max && parseInt(element.max) === 24 && value > parseInt(element.max)) || (element.min && parseInt(element.min) === 6 && value < parseInt(element.min))) {
            setError(currentValue => ({
                ...currentValue,
                [name]: `Value should be between 6 months - 3 years`,
            }));
        }
        else if (name.includes("INFLATION")) {
            if ((element.max && value > parseInt(element.max))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Maximum inflation rate should be ${element.max}%`,
                }));
            } else if ((element.min && value < parseInt(element.min))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Minimum inflation rate should be ${element.min}%`,
                }));
            }
            else {
                setError(current => {
                    const copy = { ...current };
                    delete copy[name];
                    return copy;
                });
            }
        }
        else if (name.includes("WITHDRAWAL_RATE")) {
            if ((element.max && value > parseInt(element.max))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Maximum withdrawal rate should be ${element.max}%`,
                }));
            } else if ((element.min && value < parseInt(element.min))) {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Minimum withdrawal rate should be ${element.min}%`,
                }));
            }
            else {
                setError(current => {
                    const copy = { ...current };
                    delete copy[name];
                    return copy;
                });
            }
        }
        else if ((element.max && value > parseInt(element.max)) || (element.min && value < parseInt(element.min))) {
            if (['FV', 'PV', 'COST', 'AMOUNT', 'PMT', 'MONTHLY_EXPENSES'].some(type => name.includes(type))) {
                if ((element.max && value > parseInt(element.max))) {
                    setError(currentValue => ({
                        ...currentValue,
                        [name]: `Maximum amount should be <span class="">${convertAmountToWords(element.max)}`,
                    }));
                }
                else if ((element.min && value < parseInt(element.min))) {
                    setError(currentValue => ({
                        ...currentValue,
                        [name]: `Minimum amount should be <span class="">${convertAmountToWords(element.min)}`,
                    }));
                }
            }
            else {
                setError(currentValue => ({
                    ...currentValue,
                    [name]: `Value should be between ${element.min + ' ' + (parseInt(element.min) === 1 ? 'year' : unit)} - ${element.max + ' ' + unit}`,
                }));
            }
        } else {
            setError(current => {
                const copy = { ...current };
                delete copy[name];
                return copy;
            });
        }
    }

    const handleNext = (disableNext) => {
        setNextDisabled(disableNext);
    }

    const onChange = (name, value) => {
        let element = document.getElementsByName(name)[0];
        if (value) {
            if (name.includes("COST_HOME")) {
                let elementt = document.querySelectorAll('input[name$="PV"]')[0];
                setValues(currentValue => ({
                    ...currentValue,
                    // [name]: value.match(/\d/g).join("") + inputValues.get(name.split("_")[1]),
                    [name]: parseFloat(value),
                    [elementt.name]: parseInt(value / 5),
                }));
            }
            var queryParam = getQueryParams();
            if (queryParam && queryParam.journey === 'GOAL_PLANNING') cookie.remove('GoalData')
            setValues(currentValue => ({
                ...currentValue,
                // [name]: value.match(/\d/g).join("") + inputValues.get(name.split("_")[1]),
                [name]: parseFloat(value),
            }));
        }
        else {
            if (name.includes("COST_HOME")) {
                let elementt = document.querySelectorAll('input[name$="PV"]')[0];
                setValues(current => {
                    const copy = { ...current };
                    delete copy[name];
                    elementt.value = '';
                    delete copy[elementt.name];
                    return copy;
                });
            }
            setValues(current => {
                const copy = { ...current };
                delete copy[name];
                return copy;
            });
        }
        onBlur(name, value);
    }

    const onOtpSubmit = async (OTP) => {
        closePopup();
        setOtp(OTP);
        setJourneyPage(4);
    }

    const onSubmit = (authValues, kycData) => {
        setAuthvalues(currentValue => ({
            ...currentValue,
            pan: authValues.pan,
            dob: authValues.dob,
            mobile: authValues.mobile,
            email: authValues.email,
        }));
        if (kycData && kycData.data && kycData.data.kycVerifiedFlag) {
            handleGoalSuggestionApi(authValues);
            setKycData(kycData);
            let modalData = {
                closeAction: closePopup,
                modalClass: 'verify-otp-modal',
                maskedMobile: kycData && kycData.data && kycData.data.maskedMobile ? kycData.data.maskedMobile : '',
                maskedEmail: kycData && kycData.data && kycData.data.maskedEmail ? kycData.data.maskedEmail : '',
                onOtpSubmit,
                verifyOTP,
                resendOTP,
                secretLink: kycData && kycData.data && kycData.data.secretLink,
                dob: authValues.dob,
                pan: authValues.pan,
                journey: ACTION.JOURNEY.GOAL_JOURNEY,
                registrationType: kycData && kycData.data && kycData.data.registrationType,
                encrypt: encryptAES,
                decrypt: decryptAES,
            }
            openPopup(MODALS.VERIFY_OTP, modalData)
        } else if (kycData && kycData.data && kycData.data.registrationType == 'NEW' && kycData.data.kycStatus == 'NOT_VALIDATED') {
            let modalData = {
                modalClass: 'ekyc-validate-modal',
                kycData: kycData.data,
                okAction: okAction,
                cleanAuthContent: cleanAuthContent,
            }
            openPopup(MODALS.EKYC_VALIDATE_MODAL, modalData)
        } else if (kycData && kycData.data && kycData.data.registrationType == 'NEW' && kycData.data.kycStatus == 'HOLD') {
            let modalData = {
                modalClass: 'ekyc-validate-modal',
                kycData: kycData.data,
                okAction: okAction,
                cleanAuthContent: cleanAuthContent,
            }
            openPopup(MODALS.EKYC_VALIDATE_MODAL, modalData)
        }

        else setJourneyPage(3);
    }

    const onQuestionSubmit = async () => {
        window.scrollTo({
            top: 2100,
            behavior: "smooth",
        });
        let questionArray = [];
        if (homePage.goalsQuestion && homePage.goalsQuestion.data) {
            Object.keys(values).map((item, index) => {
                let object = {};
                object.questionId = item.split("_")[0];
                object.questionType = item.split(/_(.*)/s)[1];
                object.answer = ((item.split("_")[1] === 'TIME') && (selectedGoal.goalName !== "Travel")) ? (selectedGoal.goalCategory === "EMERGENCY_CORPUS" ? parseInt(Object.values(values)[index]) : (parseInt(Object.values(values)[index])) * 12) : parseInt(Object.values(values)[index]);
                questionArray.push(object);
            })
            setgoalAllQuestionData(questionArray);

            setJourneyPage(2);
        }
    }
    const handleGoalSuggestionApi = async (authData) => {
        let params = {
            goalId: getQueryParams && getQueryParams().goalId ? getQueryParams().goalId : homePage.goalsQuestion.data.goalId,
            goalQuestionDetailSet: goalAllQuestionData,
            panNumber: authData.pan
        }
        if (homePage.goalsQuestion.data.riskQuesApplicable || showRiskAppetiteAnyway) {
            params.riskAppetite = riskAppetite && riskAppetite.toUpperCase().replace(/ /g, "_");
        }
        let response = await getGoalSuggestions(params);
    }
    const onGoalClick = async (goal) => {
        setSelectedGoal(goal);
        setDisabled(false);
        setGoalDescription(goal.goalDescription);
        setJourneyPage(1);
        let response = await getGoalQuestions(goal.goalId);
        if (response && response.data && response.data.goalQuestions &&
            Array.isArray(response.data.goalQuestions)) {
            setNumberOfQuestions(response.data.goalQuestions.length);
            response.data.goalQuestions.map(item => {
                if (item.defaultValue) {
                    setValues(currentValue => ({
                        ...currentValue,
                        [item.id + '_' + item.questionType]: item.questionType === 'TIME' && !item.questionName.toLowerCase().includes('month') && !item.questionName.toLowerCase().includes('planning to travel') ? item.defaultValue / 12 : item.defaultValue,
                    }));
                } else if (item.questionName.toLowerCase().includes('down payment')) {
                    setValues(currentValue => ({
                        ...currentValue,
                        [item.id + '_' + item.questionType]: 2000000,
                    }));
                }
            });
            if (response.data.riskQuesApplicable) {
                setRiskAppetite("Moderate");
            }
            else {
                setRiskAppetite("");
            }
        }
    }

    const riskAppetiteSelect = (event) => {
        setRiskAppetite(event.target.value);
    }

    useEffect(() => {
        if (riskAppetite == "") {
            if (showRiskAppetiteAnyway) {
                setRiskAppetite("Moderate");
            }
            else {
                setRiskAppetite("");
            }
        }
    }, [showRiskAppetiteAnyway]);

    useEffect(() => {
        const exec = async () => {
            if (journeyPage === 1) {
                let response = await getGoalQuestions(selectedGoal.goalId);
                if (response && response.data && response.data.goalQuestions &&
                    Array.isArray(response.data.goalQuestions)) {
                    setNumberOfQuestions(response.data.goalQuestions.length);
                    setgoalPlanningName(response.data.goalName);
                    // response.data.goalQuestions.map(item => {
                    //     if(item.defaultValue){
                    //         setValues(currentValue => ({
                    //             ...currentValue,
                    //             [item.id+'_'+item.questionType]: item.questionType === 'TIME' ? item.defaultValue/12 : item.defaultValue,
                    //         }));
                    //     }
                    // });
                    if (response.data.riskQuesApplicable) {
                        setRiskAppetite("Moderate");
                    }
                    else {
                        setRiskAppetite("");
                    }
                }
                let scrollToElement = require('scroll-to-element');
                scrollToElement(document.querySelector(".invest-smart"), {
                    ease: 'linear',
                    duration: 100,
                });
            } else if (journeyPage === 0) {
                let scrollToElement = require('scroll-to-element');
                scrollToElement(document.querySelector(".invest-smart"), {
                    ease: 'linear',
                    duration: 100,
                });
                await cleanGoalsQuestion();
            }
        }
        exec();
    }, [journeyPage])

    const getQueryParams = () => {
        // this func will return an object whose keys represent query keys and value represemts value mapped with queries
        // {journey : "investmentPersonality"}
        var queryParam = location.search;
        queryParam = queryParam.slice(1);
        var queries = queryParam.split("&");
        var result = {};
        queries.forEach((ele) => {
            var key = ele.split("=")[0];
            var value = ele.split("=")[1];
            result[key] = value;
        });
        return result;
    };

    const onEvaluateClick = () => {
        let goalData = {}, goalErrors = {};
        goalData = values;
        goalErrors = error;
        cookie.save("GoalData", goalData, { path: '/' });
        cookie.save("GoalErrors", goalErrors, { path: '/' });
        history.push(`/?goalId=${selectedGoal ? selectedGoal.goalId : getQueryParams().goalId}&journey=INVESTMENT_PERSONALITY`);
        switchToRisk();
    }

    const getSliderValue = (item) => {
        let sliderValue = -1;
        var queryParam = getQueryParams();
        if (queryParam && queryParam.journey && cookie.load('GoalData') && cookie.load('GoalData')[item.id + '_' + item.questionType]) {
            sliderValue = cookie.load('GoalData')[item.id + '_' + item.questionType];
        }
        else if (values[item.id + '_' + item.questionType]) {
            //    if((item.questionType === 'TIME') && !item.questionName.toLowerCase().includes('month'))  sliderValue = values[item.id+'_'+item.questionType]/12;
            //    else 
            sliderValue = values[item.id + '_' + item.questionType];
        }
        else {
            sliderValue = ((item.questionType === 'TIME') && !item.questionName.toLowerCase().includes('month')) ? item.defaultValue / 12 : item.defaultValue;
        }
        return sliderValue;
    }

    const onStartInvesting = async (schemeName) => {
        let questionArray = [];
        if (homePage.goalsQuestion && homePage.goalsQuestion.data) {
            Object.keys(values).map((item, index) => {
                let object = {};
                object.questionId = item.split("_")[0];
                object.questionType = item.split(/_(.*)/s)[1];
                object.answer = parseInt(Object.values(values)[index]);
                questionArray.push(object);
            })
            let goalsSuggestionData = homePage.goalSuggestion.data;
            let params = {
                goalId: homePage.goalsQuestion.data.goalId,
                goalQuesAndAnsSet: questionArray,
                journey: ACTION.JOURNEY.GOAL_JOURNEY,
                step: 'FIRST',
                panNumber: authvalues.pan,
                timeInMonths: goalsSuggestionData && goalsSuggestionData.timeInMonths ? goalsSuggestionData.timeInMonths : '',
                returnRate: goalsSuggestionData && goalsSuggestionData.returnRate ? goalsSuggestionData.returnRate : '',
                amount: goalsSuggestionData && goalsSuggestionData.amount ? goalsSuggestionData.amount : goalsSuggestionData && goalsSuggestionData.schemes && goalsSuggestionData.schemes[0].amount,
                transactionType: goalsSuggestionData && goalsSuggestionData.transactionType ? goalsSuggestionData.transactionType : '',
                basket: goalsSuggestionData && goalsSuggestionData.basket,
                schemes: goalsSuggestionData && goalsSuggestionData.schemes ? goalsSuggestionData.schemes.filter(item => item.schemeName === schemeName) : null,
                basketDetails: goalsSuggestionData && goalsSuggestionData.basketDetails ? goalsSuggestionData.basketDetails : null,
                nriFlag: cookie.load("taxData"),
            }
            if (riskAppetite) {
                params.riskAppetite = riskAppetite && riskAppetite.toUpperCase().replace(/ /g, "_");
            }
            let response = await savePreLoginData(encryptAES(JSON.stringify(params)), homePage.otpVerificationData.data.uuid);
        }

        const url = homePage.otpVerificationData && homePage.otpVerificationData.data && homePage.otpVerificationData.data.uuid ? `${ENV_CONFIG.INVESTOR_BASE_URL}/invest-now?id=${homePage.otpVerificationData.data.uuid}` : '';
        cookie.load('GoalData') && cookie.remove('GoalData');
        cookie.load('GoalErrors') && cookie.remove('GoalErrors');
        setDisabled(true);
        setJourneyPage(0);
        setValues({});
        setError({});
        setAuthvalues(currentValue => ({
            ...currentValue,
            pan: '',
            dob: '',
            mobile: '',
            email: '',
        }));
        cleanAuthContent();
        window.open(url, '_blank');
    }

    const onBack = () => {
        journeyPage != 0 && setJourneyPage(1);
    }

    const resetGoalData = () => {
        setValues({});
        setError({});
        cookie.load('GoalData') && cookie.remove('GoalData');
        cookie.load('GoalErrors') && cookie.remove('GoalErrors');
    }

    const okAction = () => {
        setJourneyPage(0);
    }

    return (
        <div className='journeydiv investment-basket-journeys goals-planning main-section clearfix'>
            {/* <SecondaryNav {...props} className={'new-website'} /> */}
            {homePage.allGoals.apiLoaded ? scrollHeight >= 120 && (<div className="content-section clearfix">
                <div className="container">
                    <div className="journey">
                        {/* {journeyPage!==3 && <ul className="steps">
                            <li className={journeyPage === 0 ? 'step active' : 'step'} onClick={() => {cookie.load('GoalData') && cookie.remove('GoalData');cookie.load('GoalErrors') && cookie.remove('GoalErrors'); history.push('/goal-planning'); setDisabled(true); journeyPage !==4 && setJourneyPage(0);journeyPage !==4 && setValues({});journeyPage !==4 && setError({});}}>
                            Select Goal<img className={`arrowIcon ${journeyPage === 0 && "activeArrow"}`} src='/images/investment-basket/goal-planning/Arrow.svg'/></li>
                            <li className={`step ${journeyPage === 1 && 'active'} ${(disabled || journeyPage === 0) && 'disabled'}`}  onClick={() => journeyPage !==4 && journeyPage!=0 && !disabled && setJourneyPage(1)}>
                            Calculate<img className={`arrowIcon ${journeyPage === 1 && "activeArrow"}`} src='/images/investment-basket/goal-planning/Arrow.svg'/></li>
                            <li className={`step ${journeyPage > 1 && 'active'} ${(disabled || !homePage.goalSuggestion.apiLoaded || (homePage.goalSuggestion.apiLoaded && journeyPage == 1)) && 'disabled'}`} onClick={() => !disabled && homePage.goalSuggestion.apiLoaded && journeyPage!==1 && setJourneyPage(2)}>
                            Review & Invest<img className={`arrowIcon ${journeyPage > 1 && "activeArrow"}`} src='/images/investment-basket/goal-planning/Arrow.svg'/></li>
                        </ul>} */}
                        {journeyPage === 0 &&
                            <div className='select-goals'>
                                <ul>
                                    {homePage.allGoals && homePage.allGoals.goalDetailDTOList && homePage.allGoals.goalDetailDTOList
                                        .sort((a, b) => a.sequence > b.sequence ? 1 : -1)
                                        .map((item, index) =>
                                            <li key={index} className="goal-name" onClick={() => onGoalClick(item)}>
                                                <div className={"icon " + item.goalCategory}>
                                                </div>
                                                <p>{item.goalName}</p>
                                            </li>
                                        )}
                                </ul>
                            </div>}
                        {journeyPage === 1 && homePage.goalsQuestion &&
                            <div className='questionairre'>
                                <h4 className="goal-name">
                                    {homePage.goalsQuestion.data && homePage.goalsQuestion.data.goalName === 'Children & Education' ? 'Child Education Costs' : homePage.goalsQuestion.data && homePage.goalsQuestion.data.goalName === 'My Home' ? 'My Future Home' : homePage.goalsQuestion.data && homePage.goalsQuestion.data.goalName}
                                </h4>
                                {/* <p className="goal-description">{goalDescription}</p> */}
                                {homePage.goalsQuestion.data &&
                                    homePage.goalsQuestion.data.goalQuestions &&
                                    homePage.goalsQuestion.data.goalQuestions
                                        .sort((a, b) => a.sequence > b.sequence ? 1 : -1)
                                        .map((item, index) => {
                                            return (
                                                <div className="question" key={index}>
                                                    <div className='slider'>
                                                        <p>{item.questionName}</p>
                                                        {__CLIENT__ && item.defaultValue && item.minValue && item.maxValue && item.questionType !== 'LIFE_EXPECTANCY' && !item.questionType.includes('FV') && (['TIME', 'INFLATION', 'MONTHS', 'WITHDRAWAL_RATE'].some(type => item.questionType.includes(type))) ?
                                                            (['Travel', 'Emergency Corpus'].indexOf(homePage.goalsQuestion.data.goalName) !== -1 ? <Slider
                                                                forGoalTravel
                                                                goalName={homePage.goalsQuestion.data.goalName}
                                                                min={item.minValue}
                                                                max={item.maxValue}
                                                                value={values[item.id + '_' + item.questionType] ? values[item.id + '_' + item.questionType] : item.defaultValue}
                                                                // value={getSliderValue(item)}
                                                                step={1}
                                                                unit={item.questionName.includes("months") ? "Months" : (Array.from(inputValues.keys()).some(type => item.questionType.includes(type)) ? inputValues.get(item.questionType) : "")}
                                                                minUnit="months"
                                                                noFocus
                                                                maxUnit="years"
                                                                name={item.id + '_' + item.questionType}
                                                                onChange={onChange}
                                                                handleNext={handleNext}
                                                                fromGoalJourney
                                                                maxlength={item.maxValue.toString().length}
                                                                errorMsg={error[item.id + '_' + item.questionType]}
                                                                isNumeric
                                                            /> :
                                                                <Slider
                                                                    min={(item.questionType === 'TIME' && !item.questionName.toLowerCase().includes('month')) ? item.minValue / 12 : item.minValue}
                                                                    max={(item.questionType === 'TIME' && !item.questionName.toLowerCase().includes('month')) ? item.maxValue / 12 : item.maxValue}
                                                                    // value={item.defaultValue}
                                                                    value={getSliderValue(item)}
                                                                    noFocus
                                                                    step={item.questionName.includes("travel") ? 0.1 : 1}
                                                                    unit={item.questionName.includes("months") ? "Months" : (Array.from(inputValues.keys()).some(type => item.questionType.includes(type)) ? inputValues.get(item.questionType) : "")}
                                                                    differentLowerUnit={(item.questionType === 'TIME' ? item.minValue === 12 : item.minValue === 1) ? (item.questionName.includes("months") ? "Months" : (Array.from(singularInputValues.keys()).some(type => item.questionType.includes(type)) ? singularInputValues.get(item.questionType) : "")) : null}
                                                                    name={item.id + '_' + item.questionType}
                                                                    onChange={onChange}
                                                                    handleNext={handleNext}
                                                                    fromGoalJourney
                                                                    maxlength={item.maxValue.toString().length}
                                                                    errorMsg={error[item.id + '_' + item.questionType]}
                                                                    isNumeric
                                                                />) :
                                                            <Input name={item.id + '_' + item.questionType}
                                                                value={getQueryParams().journey && cookie.load('GoalData') && cookie.load('GoalData')[item.id + '_' + item.questionType] ? cookie.load('GoalData')[item.id + '_' + item.questionType] : values[item.id + '_' + item.questionType]}
                                                                min={(item.questionType === 'TIME' && !item.questionName.toLowerCase().includes('month') && item.minValue) ? item.minValue / 12 : item.minValue}
                                                                max={(item.questionType === 'TIME' && !item.questionName.toLowerCase().includes('month') && item.maxValue) ? item.maxValue / 12 : item.maxValue}
                                                                errorMessage={error[item.id + '_' + item.questionType]}
                                                                // required={true}
                                                                autoFocus={index === 0 ? true : false}
                                                                onChange={onChange}
                                                                unit={Array.from(inputValues.keys()).some(type => item.questionType.includes(type)) ? inputValues.get(item.questionType) : ""}
                                                                formDataClass={['FV', 'PV', 'COST', 'AMOUNT', 'PMT', 'EXPENSE'].some(type => item.questionType.includes(type)) ? 'rupee-included' : 'rupee-excluded'}
                                                                ref={ref}
                                                                // maxLength={item.maxValue.toString().length}
                                                                isNumeric
                                                                fromGoalJourney
                                                                maxLength={21}
                                                            // blurChange={this.validateChange}
                                                            // labelName="First Name"
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })}

                                {homePage.goalsQuestion.data && ((homePage.goalsQuestion.data.riskQuesApplicable && (homePage.goalsQuestion.data.goalCategory != 'RETIREMENT' && homePage.goalsQuestion.data.goalCategory != 'MY_NEST')) || ((homePage.goalsQuestion.data.goalCategory === 'RETIREMENT' || homePage.goalsQuestion.data.goalCategory === 'MY_NEST') && showRiskAppetiteAnyway)) && <div className="risk-profile-dropdown">
                                    <div className='dropdown-container'>
                                        <h4>{homePage.goalsQuestion.data.riskAppetiteQues ? homePage.goalsQuestion.data.riskAppetiteQues : 'Your Investment Personality'}</h4>
                                        <div className={getQueryParams().journey && getQueryParams().journey === 'GOAL_PLANNING' ? "select-wrapper disabled" : "select-wrapper"}>
                                            <select name="severity" id="severity" onChange={riskAppetiteSelect} value={riskAppetite} disabled={getQueryParams().journey && getQueryParams().journey === 'GOAL_PLANNING'}>
                                                <option value="Very Aggressive">Very Aggressive</option>
                                                <option value="Aggressive">Aggressive</option>
                                                <option selected value="Moderate">Moderate</option>
                                                <option value="Moderately Conservative">Moderately Conservative</option>
                                                <option value="Conservative">Conservative</option>
                                            </select>
                                        </div>
                                        <a onClick={onEvaluateClick}>Take a questionnaire to find out your risk appetite.</a>
                                    </div>
                                    <div><img className='riskometer' src={`/images/investment-basket/risk-profile/${riskAppetite}.svg`} alt='riskometer icon'></img></div>
                                </div>
                                }
                                <div className="buttons">
                                    <button onClick={() => { setJourneyPage(0); setValues({}); setError({}); cookie.load('GoalData') && cookie.remove('GoalData'); cookie.load('GoalErrors') && cookie.remove('GoalErrors'); history.push('/'); }} className='back submit'>Back</button>
                                    <button onClick={() => onQuestionSubmit()} className={nextDisabled ? 'disabled submit' : 'submit'}
                                        disabled={nextDisabled}>Submit</button>
                                </div>
                            </div>}
                        {journeyPage === 2 &&
                            <div className="authentication-section">
                                <Authentication onSubmit={onSubmit} authValues={authvalues} onBack={onBack} journey={ACTION.JOURNEY.GOAL_JOURNEY} setJourneyPage={setJourneyPage} resetGoalData={resetGoalData} goalPlanningName={goalPlanningName} />
                            </div>
                        }
                        {journeyPage === 3 &&
                            <div className="not-kyc-verified">
                                <p className='kycPage-title'>Welcome to the HDFC Family!</p>
                                <p>Kindly complete your KYC to start your investment journey</p>
                                <a href={`${ENV_CONFIG.INVESTOR_BASE_URL}/ekyc?prefill=${redirectionLink}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="complete-kyc">
                                    COMPLETE KYC
                                </a>
                            </div>
                        }
                        {journeyPage === 4 &&
                            <div className={homePage.goalSuggestion.data.schemes && homePage.goalSuggestion.data.schemes.length > 0 && "schemeRecommendation"}>
                                {homePage.goalSuggestion && homePage.goalSuggestion.data && homePage.goalSuggestion.data.basket ?
                                    <div className="recommendation-basket">
                                        <div className='resetbutton'>
                                            <button onClick={handleResetBasketData}>Reset</button>
                                        </div>
                                        <div className="sip-amount">
                                            <h4>{homePage.goalSuggestion.data.transactionType === 'PURCHASE' ? 'Lumpsum' : homePage.goalSuggestion.data.transactionType} amount : </h4>
                                            <p><i className='icon-rupee-symbol' />{digitToRupeeNotation(goalAmount)}</p>
                                        </div>
                                        <h4>Basket Recommendation :</h4>
                                        <div className="basket">
                                            <div className="basket-title">
                                                {editBasketTitle && editBasketValue ? <p className='basket-name'>{homePage.goalSuggestion.data.basketDetails.basketName}</p> :
                                                    <p className='basket-name'>{homePage.goalSuggestion.data.suggestedBasketName}</p>}
                                                {editBasketValue ? <img src="/images/New/editRed.svg" onClick={() => seteditBasketValue(false)} /> :
                                                    <button
                                                        disabled={(basketValidationError && (
                                                            Object.keys(basketValidationError.sipError).length > 0 ||
                                                            Object.keys(basketValidationError.purchaseError).length > 0
                                                        ))}
                                                        onClick={handleSaveBasketData}
                                                    >
                                                        Save
                                                    </button>}
                                            </div>
                                            {basketDeatilsData && basketDeatilsData.schemesInBasket && basketDeatilsData.schemesInBasket.length > 0 &&
                                                basketDeatilsData.schemesInBasket.map((item, index) => <div key={index} className="schemes-in-basket">
                                                    <div className="scheme-row">
                                                        <div className='errormsg'>
                                                            <a href={`/product-solutions/overview/${item.linkUrl}/direct`}>
                                                                <p className="name">
                                                                    {item.schemeName}
                                                                </p>
                                                            </a>
                                                            {basketValidationError &&
                                                                (basketValidationError.sipError && basketValidationError.sipError[item.schemeCode] ||
                                                                    basketValidationError.purchaseError && basketValidationError.purchaseError[item.schemeCode]) ?
                                                                <span>{basketValidationError.sipError && basketValidationError.sipError[item.schemeCode] ||
                                                                    basketValidationError.purchaseError && basketValidationError.purchaseError[item.schemeCode]}
                                                                </span> : ""}
                                                        </div>
                                                        {editBasketValue ?
                                                            <p className="amount">
                                                                <i className='icon-rupee-symbol' />{digitToRupeeNotation(item.amount)}
                                                            </p> :
                                                            <Input
                                                                name={item.schemeName}
                                                                value={item.amount}
                                                                onChange={() => {
                                                                    onAmountChange({
                                                                        name: item.schemeName,
                                                                        value: event.target.value,
                                                                        schemeCode: item.schemeCode
                                                                    });
                                                                }}
                                                                formDataClass={'rupee-included'}
                                                                placeholder="₹ 0"
                                                                maxLength={basketValidation && basketValidation[item.schemeCode] && basketValidation[item.schemeCode].validationType === "SIP" ? 12 : 14}
                                                                isNumeric
                                                                fromGoalJourney
                                                            />}
                                                    </div>
                                                </div>)}
                                        </div>
                                        {selectedGoal.goalCategory === 'RETIREMENT' && <div className="static-redirection">
                                            <p>OR</p>
                                            <a href="https://www.hdfcfund.com/product-solutions/retirement-planning" target="_blank" rel="noreferrer">Choose from our Retirement Funds</a>
                                        </div>}
                                        <a className="submit start-investing" onClick={onStartInvestingNew}>
                                            Start Investing
                                        </a>
                                    </div>
                                    :
                                    homePage.goalSuggestion.data.schemes &&
                                    homePage.goalSuggestion.data.schemes.map((item) => {
                                        if ((selectedGoal.goalCategory === "TAX_PLANNING") && item.schemeName.includes('Tax')) {
                                            return (
                                                <div key={item.schemeName} className={`recommendation ${homePage.goalSuggestion.data.schemes.length > 1 && "schemes"}`}>
                                                    <h4>Scheme Recommendation</h4>
                                                    <div className="sip-amount">
                                                        <h4>{homePage.goalSuggestion.data.transactionType} amount : </h4>
                                                        <p><i className='icon-rupee-symbol' />{homePage.goalSuggestion.data.amount ? digitToRupeeNotation(homePage.goalSuggestion.data.amount) : digitToRupeeNotation(homePage.goalSuggestion.data.schemes[0].amount)}</p>
                                                    </div>
                                                    <div className="scheme">
                                                        <a href={`/product-solutions/overview/${item.linkUrl}/direct`}>
                                                            <p>{item.schemeName}</p>
                                                        </a>
                                                    </div>
                                                    {item.schemeName.includes('Tax') && <div className="static-redirection">
                                                        <p>OR</p>
                                                        <a href="https://www.hdfcfund.com/our-products/tax-savings" target="_blank" rel="noreferrer">Choose from our Tax Saving Funds</a>
                                                    </div>}
                                                    <a onClick={() => onStartInvesting(item.schemeName)}
                                                        className="submit start-investing">
                                                        Start Investing
                                                    </a>
                                                </div>
                                            )
                                        }
                                        else if ((selectedGoal.goalCategory !== "TAX_PLANNING")) {
                                            return (
                                                <div key={item.schemeName} className={`recommendation ${homePage.goalSuggestion.data.schemes.length > 1 && "schemes"}`}>
                                                    <h4>Scheme Recommendation</h4>
                                                    <div className="sip-amount">
                                                        <h4>{homePage.goalSuggestion.data.transactionType} amount : </h4>
                                                        <p><i className='icon-rupee-symbol' />{homePage.goalSuggestion.data.amount ? digitToRupeeNotation(homePage.goalSuggestion.data.amount) : digitToRupeeNotation(homePage.goalSuggestion.data.schemes[0].amount)}</p>
                                                    </div>
                                                    <div className="scheme">
                                                        <a href={`/product-solutions/overview/${item.linkUrl}/direct`}>
                                                            <p>{item.schemeName}</p>
                                                        </a>
                                                    </div>
                                                    <a onClick={() => onStartInvesting(item.schemeName)}
                                                        className="submit start-investing">
                                                        Start Investing
                                                    </a>
                                                </div>
                                            )
                                        }
                                    }
                                    )}
                            </div>
                        }
                        {journeyPage === 4 && <div className='disclaimer'>
                            <div className='disclaimer-head'>
                                <span>Disclaimers:</span>
                            </div>
                            <div className='disclaimer-text'>
                                <p className='disclaimer-text-top'>
                                    For Complete details of the schemes including Riskometer, product label, scheme related documents or to see other schemes offered by HDFC Mutual Fund, refer to the product pages <a href='/product-solutions'>click here</a>.
                                </p>
                                {/* {readMore && */}
                                <p className='disclaimer-text-bottom'>
                                    Important Notes and Disclaimers: The mean of 10-year rolling returns between 01/06/13 and 30/05/23 for various benchmarks are as follows: Equity (Nifty 50): 12.93%, Debt (10-year G-Sec): 7.2%, 75% Equity and 25% Debt -11.5%, 25% Equity and 75% Debt -8.63%, 50 % Equity and 50 % Debt -10.07%. However, the SIP amounts shown above have been derived using the following underlying returns: Equity: 12%, Debt: 6%, 75% Equity and 25% Debt -10.5%, 25% Equity and 75% Debt -7.5%, 50 % Equity and 50 % Debt -9%. These are not indicative of future returns of any schemes. Past performance may or may not be sustained in future and is not a guarantee of any future returns.
                                </p>
                                <p className='disclaimer-text-bottom'>
                                    The information contained herein is to help you to plan and invest for your financial goal based on your risk profile in a diversified and convenient manner.  The scheme(s) recommended are only suggestions and there is no guarantee of achievement of your goals. Investors are free to choose other schemes and proportions for their investments. Investors may invest in different schemes by logging in separately. Investment in each scheme will be distinct and governed by the terms and conditions of that scheme.
                                </p>
                                <p className='disclaimer-text-bottom'>
                                    Investors are requested to note that the above investment suggestions should not be construed as financial planning / investment advice by HDFC Mutual Fund/ HDFC AMC. The above suggestions do not in any manner, indicate or imply either the quality of any particular Scheme or guarantee any specific performance/returns. It does not have regard to specific investment objectives, financial situation and the particular needs of any specific person. The information/ data herein alone is not sufficient and should not be used for the development or implementation of an investment strategy. Neither HDFC AMC and HDFC Mutual Fund nor any person connected with them, accepts any liability arising from the use of information herein. Investor before acting on any information herein should make his/her/their own investigation and seek appropriate professional advice and shall alone be fully responsible / liable for any decision taken on the basis of information contained herein.
                                </p>
                                {/* } */}
                                {/* <a onClick={() => setReadMore(!readMore)} className="read-more">{readMore ? 'Read Less' : 'Read More'}</a> */}
                            </div>
                        </div>}
                    </div>
                </div>
            </div>) : <NoContent />}
        </div>
    );
}

const mapStateToProps = (state) => ({
    commonContent: state.commonContent,
    homePage: state.homePage,
});

const mapDispatchToProps = (dispatch) => ({
    getGoals: bindActionCreators(getGoals, dispatch),
    getGoalQuestions: bindActionCreators(getGoalQuestions, dispatch),
    getGoalSuggestions: bindActionCreators(getGoalSuggestions, dispatch),
    savePreLoginData: bindActionCreators(savePreLoginData, dispatch),
    cleanGoalsContent: bindActionCreators(cleanGoalsContent, dispatch),
    cleanGoalsQuestion: bindActionCreators(cleanGoalsQuestion, dispatch),
    verifyPAN: bindActionCreators(verifyPAN, dispatch),
    verifyOTP: bindActionCreators(verifyOTP, dispatch),
    resendOTP: bindActionCreators(resendOTP, dispatch),
    closePopup: bindActionCreators(closePopup, dispatch),
    openPopup: bindActionCreators(openPopup, dispatch),
    cleanAuthContent: bindActionCreators(cleanAuthContent, dispatch),
    validateBasketSchemes: bindActionCreators(validateBasketSchemes, dispatch)
});

const GoalsContainer = connect(mapStateToProps, mapDispatchToProps)(Goals);

export default withRouter(GoalsContainer);